import type TranscriptTurnView from '@UI/Store/Interviews/Views/TranscriptTurnView';
import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type TranscriptTurnFormArgs = {
	text: string;
};

/**
 * A single instance lives at a time: the one carried by the currently open turn
 * (`Hooks/useTurnRevision.ts`). `20000` mirrors the server constraint on the same field (§5.3).
 */
@ValidatedClass()
class TranscriptTurnFormData extends AbstractValidatedClass<TranscriptTurnFormArgs> {
	@constraint(Joi.string().required().max(20000), () => 'Le texte du tour est obligatoire.')
	public readonly text: string;

	constructor(data: TranscriptTurnFormArgs) {
		super(data);
		this.text = data.text;
		Object.freeze(this);
	}

	static createEmpty(): TranscriptTurnFormData {
		return new TranscriptTurnFormData({ text: '' });
	}

	static fromView(turn: TranscriptTurnView): TranscriptTurnFormData {
		return new TranscriptTurnFormData({ text: turn.text });
	}

	setText(text: string): this {
		return this.cloneWith({ text } as Partial<TranscriptTurnFormArgs>);
	}
}

export default TranscriptTurnFormData;
